import styled from 'styled-components'


export const WorksContainer = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, 443px);
  grid-gap: 50px;
  margin-top: 100px;
  align-content: center;
`